import React from "react";
import { LuChevronRight } from "react-icons/lu";

import { css, cx } from "../../styled-system/css";

export type BreadcrumbsProperties = React.ComponentProps<"nav">;
export function Breadcrumbs({ children, className, ...properties }: BreadcrumbsProperties) {
  children = Array.isArray(children) ? children : children ? [children] : [];
  return (
    <nav
      {...properties}
      className={cx(css({ alignItems: "center", display: "inline-flex", gap: "8px" }), className)}
    >
      {Array.from(children)?.flatMap(function (child, index, children) {
        return [
          child,
          index < children.length - 1 ? (
            <LuChevronRight
              className={css({ color: "#71717A", display: "block", height: "20px", width: "auto" })}
              key={index}
            />
          ) : undefined,
        ];
      })}
    </nav>
  );
}
